module.exports = __webpack_public_path__ + "235094fb89a180c950fb2fdc38983b55.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_about_4@2x.png
// module id = 219
// module chunks = 1